import React from 'react';
import { Link } from 'react-router-dom';

const industries = [
  'Real Estate', 'Healthcare', 'Retail & FMCG', 'Banking & Finance',
  'Hospitality', 'Education', 'Government', 'Media & Entertainment',
  'Manufacturing', 'IT & Technology',
];

const clientList = [
  'MTNL', 'Bank of Baroda', 'ONGC', 'NDMC', 'DLF Group',
  'Tata Group', 'Amway India', 'Ansal Housing', 'Apollo Hospitals',
  'Toshiba India', 'Star Plus', 'Omaxe Ltd.', 'Educomp Solutions',
  'Gulshan Homz', 'Birlasoft', 'Ashok Leyland', 'PFC India',
  'PMSI', 'Modern Foods', 'La Coste India', 'Aditya Birla',
  'Convergys', 'eFunds', 'Shimizu Corp.', 'PDM Group',
  'Malasiye Corp.', 'Central Bank', 'Alpha Group', 'Apollo Schools', 'Shroff Group',
];

function Clients() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <i className="fas fa-chevron-right" />
            <span>Clients</span>
          </div>
          <h1 className="page-hero-title">
            Our <span>Clients</span>
          </h1>
          <p className="section-desc light" style={{ marginTop: 16 }}>
            Proud to have served 150+ clients across India's top industries.
          </p>
        </div>
      </div>

      {/* Industries */}
      <section style={{ padding: '70px 0', background: 'var(--off-white)' }}>
        <div className="container">
          <div className="text-center">
            <span className="section-label">Sectors We Serve</span>
            <h2 className="section-title">Industries We've Worked With</h2>
          </div>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            justifyContent: 'center',
            marginTop: 48,
          }}>
            {industries.map(ind => (
              <div
                key={ind}
                style={{
                  background: 'var(--white)',
                  border: '1px solid var(--gray-200)',
                  borderRadius: 4,
                  padding: '14px 24px',
                  fontFamily: 'var(--font-condensed)',
                  fontSize: '14px',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--text-dark)',
                  transition: 'all 0.3s',
                  cursor: 'default',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'var(--secondary)';
                  e.currentTarget.style.color = 'var(--primary)';
                  e.currentTarget.style.borderColor = 'var(--secondary)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'var(--white)';
                  e.currentTarget.style.color = 'var(--text-dark)';
                  e.currentTarget.style.borderColor = 'var(--gray-200)';
                }}
              >
                {ind}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Grid */}
      <section style={{ padding: '80px 0', background: 'var(--white)' }}>
        <div className="container">
          <div className="text-center">
            <span className="section-label">Our Partners</span>
            <h2 className="section-title">Brands That Trust Us</h2>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: 1,
            background: 'var(--gray-100)',
            border: '1px solid var(--gray-100)',
            borderRadius: 12,
            overflow: 'hidden',
            marginTop: 56,
          }}
          className="clients-full-grid"
          >
            {clientList.map((c, i) => (
              <div
                key={i}
                style={{
                  background: 'var(--white)',
                  padding: '32px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                  transition: 'all 0.3s',
                  cursor: 'default',
                  textAlign: 'center',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--off-white)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'var(--white)'; }}
              >
                <div style={{
                  width: 48,
                  height: 48,
                  background: 'rgba(212,160,23,0.08)',
                  borderRadius: 8,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <i className="fas fa-building" style={{ color: 'var(--primary)', fontSize: '1.2rem' }}></i>
                </div>
                <span style={{
                  fontFamily: 'var(--font-condensed)',
                  fontSize: '0.85rem',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  color: 'var(--text-dark)',
                }}>{c}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section style={{ padding: '80px 0', background: 'var(--secondary)' }}>
        <div className="container">
          <div className="text-center">
            <span className="section-label">Client Feedback</span>
            <h2 className="section-title light">What They Say</h2>
          </div>
          <div className="testimonials-grid" style={{ marginTop: 56 }}>
            {[
              {
                text: 'Expert Advertising delivered our entire office campus wayfinding system on time and within budget. The quality exceeded our expectations.',
                name: 'Ramesh Gupta', role: 'Facility Manager, IT Corp', init: 'RG',
              },
              {
                text: 'The LED channel letters for our hospital entrance are exceptional. Patients and visitors compliment our signage regularly. Truly professional work.',
                name: 'Dr. Sunita Arora', role: 'Apollo Hospitals, Delhi', init: 'SA',
              },
              {
                text: 'We have been working with Expert Advertising for 8 years across all our branches. Consistent quality, excellent service.',
                name: 'Vikram Malhotra', role: 'Bank of Baroda, Regional Head', init: 'VM',
              },
            ].map((t, i) => (
              <div className="testimonial-card" key={i} style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(255,255,255,0.08)' }}>
                <div className="testimonial-quote" style={{ color: 'var(--primary)' }}>"</div>
                <p className="testimonial-text" style={{ color: 'rgba(255,255,255,0.7)' }}>{t.text}</p>
                <div className="testimonial-stars">
                  {[...Array(5)].map((_, j) => <i key={j} className="fas fa-star" />)}
                </div>
                <div className="testimonial-author" style={{ borderTopColor: 'rgba(255,255,255,0.1)' }}>
                  <div className="testimonial-avatar">{t.init}</div>
                  <div>
                    <div className="testimonial-name" style={{ color: 'var(--white)' }}>{t.name}</div>
                    <div className="testimonial-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section" style={{ background: 'var(--primary)' }}>
        <div className="container">
          <div className="cta-inner">
            <div>
              <h2 className="cta-title" style={{ color: 'var(--secondary)' }}>
                Join Our <span style={{ color: 'var(--secondary)', opacity: 0.7 }}>Growing Client Family</span>
              </h2>
              <p className="cta-desc" style={{ color: 'rgba(26,26,46,0.7)' }}>
                Become part of India's most trusted signage network.
              </p>
            </div>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-dark">
                Start a Project <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 1024px) {
          .clients-full-grid { grid-template-columns: repeat(4, 1fr) !important; }
        }
        @media (max-width: 768px) {
          .clients-full-grid { grid-template-columns: repeat(3, 1fr) !important; }
        }
        @media (max-width: 480px) {
          .clients-full-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </>
  );
}

export default Clients;
